jQuery(document).ready(function ($) {
  // 使用事件委托来监听所有可能的点击

  $(document).on(
    "click",

    '.wpcf7-list-item-label, .wpcf7-list-item input[type="radio"]',

    function (e) {
      var $input;

      if ($(this).is("input")) {
        $input = $(this);
      } else {
        $input = $(this).siblings('input[type="radio"]');
      }

      var name = $input.attr("data-name");

      var value = $input.val();

      // 根据name更新对应的显示元素

      switch (name) {
        case "mtsi_method":
          $("#fetch_sel_method_insta_txt1").text(value);

          break;

        case "mtsi_header_type":
          $("#fetch_sel_header_type_txt1").text(value);

          break;

        case "mtsi_panel_type":
          $("#fetch_sel_panel_txt1").text(value);

          break;

        case "mtsi_custom_curtain_lining":
          $("#fetch_sel_lining_txt1").text(value);

          break;
      }
    }
  );

  var whStep = $('div.steps-step:contains("W & H")');

  if (whStep.length && !whStep.find("#fetch_sel_width_height_txt1").length) {
    whStep.append('<p id="fetch_sel_width_height_txt1"></p>');
  }

  var liningStep = $('div.steps-step:contains("Lining")');

  if (liningStep.length && !liningStep.find("#fetch_sel_lining_txt1").length) {
    liningStep.append('<p id="fetch_sel_lining_txt1"></p>');
  }

  function updateWidthHeight() {
    var width = $("#mtsi_custom_curtain_width").val() || "";

    var height = $("#mtsi_custom_curtain_height").val() || "";

    var unit = $("#mtsi_custom_curtain_width_unit").val();

    $("#fetch_sel_width_height_txt1").text("W" + width + " " + "H" + height);
  }

  // 监听宽度和高度的变化

  $(document).on(
    "change",

    'input[id="mtsi_custom_curtain_width"], input[id="mtsi_custom_curtain_height"]',

    function () {
      // 确保输入值不为负

      if (parseFloat(this.value) < 0) {
        this.value = "0";
      }

      updateWidthHeight();
    }
  );

  // 监听单位选择的变化

  $(document).on("change", "#mtsi_custom_curtain_width_unit", function () {
    updateWidthHeight();
	  $("#mtsi_custom_unit").val($(this).val());
  });

  // 防止输入负数

  $(
    'input[data-name="mtsi_custom_curtain_width"], input[data-name="mtsi_custom_curtain_length"]'
  ).on("input", function () {
    if (this.value.startsWith("-")) {
      this.value = this.value.substring(1);
    }
  });

  // 同步单位选择

  $(".unit-select").on("change", function () {
    var selectedValue = $(this).val();

    $(".unit-select").val(selectedValue);

    // 更新隐藏的输入字段，用于表单提交

    $("#mtsi_custom_curtain_unit").val(selectedValue);

    // 触发自定义事件，以便其他可能依赖于单位的函数可以更新

    $(document).trigger("unitChanged", [selectedValue]);
  });

});